'use client';

import React from 'react';
import { QuotationProvider } from '../context/quotation-context';
import { CartProvider } from '../context/cart-context';
import Header from './Header';
import MobileNavbar from './MobileNavbar';
import QuotationConfirmation from '../(main)/cotizar/components/QuotationConfirmation';
import Image from 'next/image';
import Link from 'next/link';

export default function SharedLayout({ children }: { children: React.ReactNode }) {
  return (
    <CartProvider>
      <QuotationProvider>
        <div className="flex min-h-screen flex-col">
          <Header />
          <main className="flex-1">{children}</main>
          <footer className="bg-gray-100 py-8 mt-12 mb-16 md:mb-0">
            <div className="container mx-auto px-4">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                {/* Company Info */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Droquimar S.R.L.</h3>
                  <p className="text-sm text-gray-600 mb-2">
                    Productos químicos industriales desde 1982
                  </p>
                  <p className="text-sm text-gray-600">
                    Av. Crovara 2000/2014 (1766)<br />
                    La Tablada, Buenos Aires
                  </p>
                </div>
                
                {/* Quick Links */}
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Enlaces</h3>
                  <ul className="space-y-2">
                    <li>
                      <Link href="/informacion-tributaria" className="text-sm text-gray-600 hover:text-brand-primary transition-colors">
                        Legajo Impositivo
                      </Link>
                    </li>
                    <li>
                      <Link href="/privacidad" className="text-sm text-gray-600 hover:text-brand-primary transition-colors">
                        Política de Privacidad
                      </Link>
                    </li>
                    <li>
                      <Link href="/terminos" className="text-sm text-gray-600 hover:text-brand-primary transition-colors">
                        Términos y Condiciones
                      </Link>
                    </li>
                    <li>
                      <Link href="/contacto" className="text-sm text-gray-600 hover:text-brand-primary transition-colors">
                        Contacto
                      </Link>
                    </li>
                  </ul>
                </div>
                
                {/* AFIP Compliance */}
                <div className="flex flex-col items-center md:items-end">
                  <h3 className="text-lg font-semibold text-gray-900 mb-3">Certificación</h3>
                  <a 
                    href="https://servicios1.afip.gov.ar/clavefiscal/qr/response.aspx?qr=Xqwswxeby5vn3xkVvWdldQ,," 
                    target="_blank" 
                    rel="noopener noreferrer"
                    aria-label="AFIP Data Fiscal"
                    className="hover:opacity-90 transition-opacity"
                  >
                    <Image 
                      src="/images/DATAWEB.jpg" 
                      alt="AFIP Data Fiscal" 
                      width={60} 
                      height={90} 
                    />
                  </a>
                </div>
              </div>
              
              {/* ShareThis Social Buttons */}
              <div className="border-t border-gray-300 pt-4 mb-4">
                <div className="flex flex-col items-center space-y-2">
                  <div className="sharethis-inline-share-buttons"></div>
                  <div className="sharethis-inline-follow-buttons"></div>
                </div>
              </div>

              {/* Copyright */}
              <div className="border-t border-gray-300 pt-4">
                <div className="flex flex-col md:flex-row justify-between items-center">
                  <p className="text-sm text-gray-600 mb-2 md:mb-0">
                    Copyright © {new Date().getFullYear()} Droquimar S.R.L. Todos los derechos reservados.
                  </p>
                  <p className="text-xs text-gray-500">
                    Fundada en 1982
                  </p>
                </div>
              </div>
            </div>
          </footer>
          
          {/* Mobile Navigation */}
          <MobileNavbar />
          
          {/* Global Modals */}
          <QuotationConfirmation />
        </div>
      </QuotationProvider>
    </CartProvider>
  );
}